import { useEffect, useState, useMemo } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { postRequest } from 'src/services';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import { handleErrorMessages } from 'src/pages/components/errorhanling-formating';
import { DatePicker } from '@mui/x-date-pickers';
import { useParams } from 'react-router';
import { dateFormatter } from 'src/services/fetching';

export const CostCodesShowCreateModal = ({ open, onClose, reload, currentItem, closeform }) => {
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const [ loading, setLoading ] = useState(false);
    const [ enddate, setEndDate ] = useState();
    const [ startdate, setstartDate ] = useState();
    const { id } = useParams()

    const NewDocumentSchema = Yup.object().shape({
        // code: Yup.number().required('Code is required').max(99999999),
        // description: Yup.string().required('Description is required').max(191),
        // quantity: Yup.number(),
        // unit: Yup.string(),
        // unit_price: Yup.number(),
        // budget_amount: Yup.number(),
        // budget_hrs: Yup.number(),
        // hrly_rate: Yup.number(),
        // planned_labor_cost: Yup.number(),
        // planned_material_cost: Yup.number(),
        // planned_equipment_cost: Yup.number(),
        // planned_subcontractor_cost: Yup.number(),
        // mark_ups: Yup.number(),
        // // planned_start_date: Yup.string(),
        // // planned_finish_date: Yup.string(),
        // duration: Yup.number()
    });

    const defaultValues = useMemo(
        () => ({
            code: currentItem?.code || '',
            description: currentItem?.description || '',
            quantity: currentItem?.quantity || '',
            unit: currentItem?.unit || '',
            unit_price: currentItem?.unit_price || '',
            budget_amount: currentItem?.budgeted_amount || '',
            budget_hrs: currentItem?.budgeted_hours || '',
            hrly_rate: currentItem?.hourly_rate || '',
            planned_labor_cost: currentItem?.planned_labor_cost || '',
            planned_material_cost: currentItem?.planned_material_cost || '',
            planned_equipment_cost: currentItem?.planned_equipment_cost || '',
            planned_subcontractor_cost: currentItem?.planned_subcontractor_cost || '',
            mark_ups: currentItem?.mark_ups || '',
            planned_start_date: currentItem?.planned_start_date || '',
            planned_finish_date: currentItem?.planned_finish_date || '',
            duration: currentItem?.duration || '',
        }),
        [ currentItem ]
    );

    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });

    const { reset, handleSubmit, formState: { isSubmitting } } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();

        formData.append('code', data.code);
        formData.append('description', data.description);
        formData.append('quantity', data.quantity);
        formData.append('unit', data.unit);
        formData.append('unit_price', data.unit_price);
        formData.append('budget_amount', data.budget_amount);
        formData.append('budget_hrs', data.budget_hrs);
        formData.append('hrly_rate', data.hrly_rate);
        formData.append('planned_labor_cost', data.planned_labor_cost);
        formData.append('planned_material_cost', data.planned_material_cost);
        formData.append('planned_equipment_cost', data.planned_equipment_cost);
        formData.append('planned_subcontractor_cost', data.planned_subcontractor_cost);
        formData.append('mark_ups', data.mark_ups);
        formData.append('planned_start_date', dateFormatter(startdate));
        formData.append('planned_finish_date', dateFormatter(enddate));
        formData.append('duration', data.duration);

        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.admin_dashboard.teachnical_database.cost_codes.post_list_activity}/${id}/cost-codes?_method=PUT`
                    : `${endpoints.admin_dashboard.teachnical_database.cost_codes.post_list_activity}/${id}/cost-codes`,
                formData,
                true
            );

            if (response.metadata?.success) {
                reset();
                reload();
                onClose();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response?.metadata?.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err?.metadata?.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });


    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="md"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className='cardColor'
                        style={ {
                            padding: '7px',
                            marginLeft: '-25px',
                            fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Cost Codes Activity &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box
                        mt={ 1 }
                        rowGap={ 2 }
                        gap={ 2 }
                        display="grid"
                        gridTemplateColumns={ {
                            xs: 'repeat(2, 2fr)',
                        } }
                    >
                        <RHFTextField name="code" label="Code" type="number" />
                        <RHFTextField name="description" label="Description" />
                        <RHFTextField name="quantity" label="Quantity" type="number" />
                        <RHFTextField name="unit" label="Unit" />
                        <RHFTextField name="unit_price" label="Unit Price" type="number" />
                        <RHFTextField name="budget_amount" label="Budget Amount" type="number" />
                        <RHFTextField name="budget_hrs" label="Budget Hours" type="number" />
                        <RHFTextField name="hrly_rate" label="Hourly Rate" type="number" />
                        <RHFTextField name="planned_labor_cost" label="Planned Labor Cost" type="number" />
                        <RHFTextField name="planned_material_cost" label="Planned Material Cost" type="number" />
                        <RHFTextField name="planned_equipment_cost" label="Planned Equipment Cost" type="number" />
                        <RHFTextField name="planned_subcontractor_cost" label="Planned Subcontractor Cost" type="number" />
                        <RHFTextField name="mark_ups" label="Mark Ups" type="number" />
                        <DatePicker
                            label="Planned Start Date"
                            name="planned_start_date"
                            value={ startdate }
                            onChange={ setstartDate }
                            slotProps={ { textField: { fullWidth: true } } }
                        />
                        <DatePicker
                            label="Planned Finish Date"
                            name="planned_finish_date"
                            value={ enddate }
                            onChange={ setEndDate }
                            slotProps={ { textField: { fullWidth: true } } }
                        />
                        <RHFTextField name="duration" label="Duration (Days)" type="number" />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className='dark-button'
                        loading={ isSubmitting || loading }
                    >
                        { currentItem?.id ? "Update" : "Create" }
                    </LoadingButton>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};
